import React from 'react'
import { PageDivide } from './BrandingsElements'
import homeBg from '../../images/largeFormat.png';
function PageDivider(data) {
    return (
        <PageDivide style={{ backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.6)15%, rgba(0,0,0,0.6)), url(${homeBg})` }}>{data.data}</PageDivide>
    )
}

export default PageDivider